import React from 'react';
import PropTypes from 'prop-types';
import { StyledArticle } from './styles';
import RightArrow from 'components/ui/icons/RightArrow';
import { colors } from 'styleGuide';

const PressArticle = props => {
  return (
    <StyledArticle>
      <img src={props.headerImg} alt="" className="align-self-start" />
      <div className="quote">&ldquo;</div>
      <p>{props.quote}</p>
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        {props.linkLabel}
        <RightArrow fillColor={colors.blue.primary} />
      </a>
    </StyledArticle>
  );
};

PressArticle.propTypes = {
  headerImg: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
};

export default PressArticle;
